import React, {Component} from "react";
import Cookies from "universal-cookie";

const cookies = new Cookies();

class Menup extends Component {

    // remover todas las cookies al cerrar por seguridad
    cerrarSesion = () => {
        cookies.remove("rolidx", {path: "/"});
        cookies.remove("usrcorreo", {path: "/"});
        cookies.remove("usrestado", {path: "/"});
        cookies.remove("usrfoto", {path: "/"});
        cookies.remove("usridx", {path: "/"});
        cookies.remove("usrnombre", {path: "/"});

        // redireccionar a loghin
        window.location.href='https://jbteccr.net/testapp/#/Login';
    }

    render() {

        // capturando las cookies definidas en login
        //cookies.set("usrcorreo", data[0].usrcorreo, {path: "/"});
        //window.alert(cookies.get('usrnombre'));

        // si no se registro un usuario la manda a login
        if(!cookies.get('usrnombre')) {
            window.location.href='/login'
        }



        return(
            <div>
                Menu Opciones de Pruebas en AWS

                <br/>
                <br/>
                <button className="btn btn-primary" onClick={() => this.cerrarSesion()}>Cerrar la Sesion en AWS - ir a Login</button>

            </div>
        );
    }
}

export default Menup;